<script setup>

</script>

<template>
  <div class="app-container">
    <router-view></router-view>
  </div>
</template>

<style lang="scss">
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
</style>
